export const protocols_index = ['protocols.index']
export const protocols_create = ['protocols.create']
export const protocols_edit = ['protocols.edit']

export default [].concat(
    protocols_index,
    protocols_create,
    protocols_edit
)
